import gsap from "gsap";
function initBlock(block) {
    const generalConfig = {
        duration: 2.5,
        ease: "back.out(1.2)",
    };
    const glowElement = block.querySelector(".diensten__glow");
    const halfGlowSize = glowElement ? glowElement.offsetWidth / 2 : 150;
    if (!glowElement)
        return;
    const handleMouseEnter = (event) => {
        gsap.to(glowElement, Object.assign(Object.assign({}, generalConfig), { opacity: 0.2 }));
        const blockRect = block.getBoundingClientRect();
        const x = event.clientX - blockRect.left;
        const y = event.clientY - blockRect.top;
        gsap.set(glowElement, {
            translateX: x - halfGlowSize,
            translateY: y - halfGlowSize,
        });
        updateBorderOpacityForAllCards(event.clientX, event.clientY);
    };
    const handleMouseMove = (event) => {
        const blockRect = block.getBoundingClientRect();
        const x = event.clientX - blockRect.left;
        const y = event.clientY - blockRect.top;
        gsap.to(glowElement, Object.assign(Object.assign({}, generalConfig), { translateX: x - halfGlowSize, translateY: y - halfGlowSize }));
        updateBorderOpacityForAllCards(event.clientX, event.clientY);
    };
    const handleMouseleave = () => {
        gsap.to(glowElement, Object.assign(Object.assign({}, generalConfig), { opacity: 0 }));
        // Reset all border glow effects when mouse leaves
        const allCards = document.querySelectorAll(".dienst");
        allCards.forEach((card) => {
            gsap.to(card, {
                duration: 0.3,
                ease: "power2.out",
                "--border-glow-intensity": 0,
            });
        });
    };
    block.addEventListener("mouseenter", handleMouseEnter);
    block.addEventListener("mousemove", handleMouseMove);
    block.addEventListener("mouseleave", handleMouseleave);
    window.addNavigationCallback(() => {
        block.removeEventListener("mouseenter", handleMouseEnter);
        block.removeEventListener("mousemove", handleMouseMove);
        block.removeEventListener("mouseleave", handleMouseleave);
    }, "cleanup-diensten", false);
}
function updateBorderOpacityForAllCards(glowX, glowY) {
    const allCards = document.querySelectorAll(".dienst");
    const glowSize = 400; // Approximate size of the glow in pixels
    allCards.forEach((card) => {
        const cardRect = card.getBoundingClientRect();
        const cardCenterX = cardRect.left + cardRect.width / 2;
        const cardCenterY = cardRect.top + cardRect.height / 2;
        // Calculate distance between glow center and card center
        const distance = Math.sqrt(Math.pow(glowX - cardCenterX, 2) + Math.pow(glowY - cardCenterY, 2));
        // Calculate opacity based on distance (closer = more opaque)
        // Maximum opacity when distance is 0, fading out as distance increases
        let opacity = 1 - Math.min(distance / glowSize, 1);
        // Apply minimum threshold for visibility
        opacity = Math.max(opacity, 0.1);
        gsap.to(card, {
            duration: 0.2,
            ease: "power2.out",
            "--border-opacity": opacity,
        });
    });
}
window.addNavigationCallback(() => {
    const blocks = document.querySelectorAll(".diensten");
    blocks.forEach(initBlock);
}, "init-diensten");
